// extracted by mini-css-extract-plugin
export default {"sessaoSetas":"Setas_sessaoSetas__xwv6M","setas":"Setas_setas__rz1GH","float":"Setas_float__SWD0E"};